import { render } from "./letter-compose-step2.vue?vue&type=template&id=252ac2de"
import script from "./letter-compose-step2.vue?vue&type=script&lang=js"
export * from "./letter-compose-step2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__